import BankList from "../../components/Bank/BankList";
import TransactionList from "../../components/Transaction/TransactionList";

import PageLayout from "../../components/UI/Layout/PageLayout";
import FinanceConfigList from "../../components/Bank/FinanceConfigList";
import { Outlet, useSearchParams } from "react-router-dom";
import ContentLayout from "../../components/UI/Layout/ContentLayout.tsx";
import { Tabs } from "../../components/UI/Tabs/Tabs";
// @ts-expect-error pure js
import useBanks from "../../hooks/use-banks";
import HeaderLayout from "../../components/UI/Layout/HeaderLayout.tsx";
import type { Bank } from "../../models/bank";
import VideoTutorialsButton from "../../components/VideoTutorials/VideoTutorialsButton";
import type { TutorialPage } from "../../components/VideoTutorials/videoTutorials";

const TAB_TUTORIALS: Partial<Record<string, TutorialPage>> = {
  banques: "banques",
  transactions: "transactions",
};

const TAB_LABELS: Record<string, string> = {
  banques: "Mes banques",
  transactions: "Transactions",
  configuration: "Paramètres",
};

export default function BankRootPage() {
  const { banks, isLoading } = useBanks();
  const [searchParams, setSearchParams] = useSearchParams();
  const activeTab = searchParams.get("tab-bank") ?? "banques";
  const tutorialPage = TAB_TUTORIALS[activeTab];

  // Remplacer toute la query string réinitialise aussi les autres filtres de
  // la liste des transactions (recherche, dates, pagination…).
  function showBankTransactions(bank: Bank) {
    setSearchParams({ "tab-bank": "transactions", account: bank.unique_id });
  }

  return (
    <PageLayout isBailleur>
      <ContentLayout
        header={
          <HeaderLayout
            title={"Banques"}
            breadcrumb={[
              { label: "Tableau de bord", to: "/bailleur" },
              { label: "Banques", to: "/bailleur/finances" },
              { label: TAB_LABELS[activeTab] ?? TAB_LABELS.banques },
            ]}
            actions={
              tutorialPage && <VideoTutorialsButton page={tutorialPage} />
            }
          />
        }
        body={
          <>
            <Tabs id="bank" defaultValue="banques">
              <div className="container bg-blue paddingT10 border-blue">
                <div className="content">
                  <Tabs.List>
                    <Tabs.Tab value="banques">Mes banques</Tabs.Tab>
                    <Tabs.Tab value="transactions">Transactions</Tabs.Tab>
                    <Tabs.Tab value="configuration">Paramètres</Tabs.Tab>
                  </Tabs.List>
                </div>
              </div>
              <div className="blueSpace"></div>
              <div className="content">
                <Tabs.Panel value="banques">
                  <BankList
                    banks={banks}
                    isLoading={isLoading}
                    onShowTransactions={showBankTransactions}
                  />
                </Tabs.Panel>
                <Tabs.Panel value="transactions">
                  <TransactionList banks={banks} />
                </Tabs.Panel>
                <Tabs.Panel value="configuration">
                  <FinanceConfigList displayNom />
                </Tabs.Panel>
              </div>
            </Tabs>
            <Outlet />
          </>
        }
      />
    </PageLayout>
  );
}
